/**
 * @generated SignedSource<<6567104350f9e481356954297ffd6d9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespCondensedListedContent_viewer$data = {
  readonly showHeartCount: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedHeroCarousel_viewer" | "PdpSharedCondensedSidebarButtons_viewer" | "PdpSharedPromoCode_viewer" | "PdpSharedShippingBadge_viewer">;
  readonly " $fragmentType": "PdpRespCondensedListedContent_viewer";
};
export type PdpRespCondensedListedContent_viewer$key = {
  readonly " $data"?: PdpRespCondensedListedContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedListedContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCondensedListedContent_viewer",
  "selections": [
    {
      "alias": "showHeartCount",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "pdpDisplayHeartCount"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"pdpDisplayHeartCount\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingBadge_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCondensedSidebarButtons_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d2a4ced3a4d50414b746ed628398dca0";

export default node;
